/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1243
 */

var r = require(/* 246 */"../1782/246/index")
exports.f = r
